import { IsBoolean, IsDefined, IsNumber, IsOptional, ValidateNested } from 'class-validator';

import { Address } from '../address/address';

export interface DeliveryDistanceRaw {
    bySchedule?: boolean;
    addressFrom?: Partial<Address>;
    addressTo?: Partial<Address>;
    price?: number;
    distance?: number;
}

export class DeliveryDistance {
    @IsOptional()
    @IsBoolean()
    public bySchedule: boolean;

    @IsDefined()
    @ValidateNested()
    public addressFrom: Address;

    @IsDefined()
    @ValidateNested()
    public addressTo: Address;

    @IsDefined()
    @IsNumber()
    public price: number;

    @IsDefined()
    @IsNumber()
    public distance: number;

    constructor(data?: DeliveryDistanceRaw) {
        this.bySchedule = data?.bySchedule;
        this.addressFrom = data?.addressFrom ? new Address(data.addressFrom) : undefined;
        this.addressTo = data?.addressTo ? new Address(data.addressTo) : undefined;
        this.price = data?.price;
        this.distance = data?.distance;
    }
}
